import _ from 'underscore';

export const timeGrainRangeOptions = {
  Hourly: [
    'Today',
    'Yesterday',
    'LastSevenDays',
    'LastFourteenDays',
    'LastThirtyDays',
    'ThisWeekFromSun',
    'ThisWeekFromMon',
    'LastWeekStartingSun',
    'LastWeekStartingMon',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'Custom',
  ],
  HourOfDay: [
    'Today',
    'Yesterday',
    'LastSevenDays',
    'LastFourteenDays',
    'LastThirtyDays',
    'ThisWeekFromSun',
    'ThisWeekFromMon',
    'LastWeekStartingSun',
    'LastWeekStartingMon',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'Custom',
  ],
  Daily: [
    'Today',
    'Yesterday',
    'LastSevenDays',
    'LastFourteenDays',
    'LastThirtyDays',
    'ThisWeekFromSun',
    'ThisWeekFromMon',
    'LastWeekStartingSun',
    'LastWeekStartingMon',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
  DayOfWeek: [
    'Today',
    'Yesterday',
    'LastSevenDays',
    'LastFourteenDays',
    'LastThirtyDays',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
  Weekly: [
    'LastThirtyDays',
    'ThisWeekFromSun',
    'ThisWeekFromMon',
    'LastWeekStartingSun',
    'LastWeekStartingMon',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
  WeeklyStartingMonday: [
    'LastThirtyDays',
    'ThisWeekFromSun',
    'ThisWeekFromMon',
    'LastWeekStartingSun',
    'LastWeekStartingMon',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
  Monthly: [
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
  Yearly: [
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
  Summary: [
    'Today',
    'Yesterday',
    'LastSevenDays',
    'LastFourteenDays',
    'LastThirtyDays',
    'ThisWeekFromSun',
    'ThisWeekFromMon',
    'LastWeekStartingSun',
    'LastWeekStartingMon',
    'LastFourWeeksStartingSun',
    'LastFourWeeksStartingMon',
    'ThisMonth',
    'LastMonth',
    'LastThreeMonths',
    'LastSixMonths',
    'ThisYear',
    'LastYear',
    'AllTime',
    'Custom',
  ],
};

export const dataRetentionBlackList = {
  '36m': {
    Summary: [],
    Daily: [],
    Weekly: [],
    Monthly: [],
    Yearly: [],
    DayOfWeek: [],
    WeeklyStartingMonday: [],
  },
  '6m': {
    Hourly: [],
    HourOfDay: [],
    Summary: ['LastYear'],
    Daily: ['LastYear'],
    Weekly: ['LastYear'],
    Monthly: ['LastYear'],
    Yearly: [],
    WeeklyStartingMonday: ['LastYear'],
  },
  '12m': {
    Hourly: [],
    HourOfDay: [],
    Summary: ['LastYear'],
    Daily: ['LastYear'],
    Weekly: ['LastYear'],
    Monthly: ['LastYear'],
    Yearly: ['LastYear'],
    WeeklyStartingMonday: ['LastYear'],
  },
  '24m': {
    Daily: [],
  },
  '1m': {
    Hourly: ['LastSixMonths'],
    HourOfDay: ['LastSixMonths'],
  },
  '14d': {
    Hourly: ['LastSixMonths'],
    HourOfDay: ['LastSixMonths'],
  },
  '2m': {
    Hourly: ['LastSixMonths'],
    HourOfDay: ['LastThreeMonths'],
  },
  '90d': {
    Summary: [],
    Daily: [],
    Weekly: [],
    Monthly: [],
    Yearly: [],
    DayOfWeek: [],
    WeeklyStartingMonday: [],
  },
  '30d': {
    Hourly: [],
    HourOfDay: [],
    Summary: ['LastSixMonths', 'LastThreeMonths'],
    Daily: ['LastSixMonths', 'LastThreeMonths'],
    Weekly: ['LastSixMonths', 'LastThreeMonths'],
    Monthly: ['LastSixMonths', 'LastThreeMonths'],
    Yearly: [],
    WeeklyStartingMonday: ['LastSixMonths', 'LastThreeMonths'],
  },
};

export const getAllowedRanges = (timeGrain, reportSchema) => {
  const reportDateRetention = reportSchema.DataRetention[timeGrain] || Object.values(reportSchema.DataRetention)[0];
  const blackList = dataRetentionBlackList[reportDateRetention][timeGrain];
  return reportSchema.TimeRanges ?
    reportSchema.TimeRanges[timeGrain] :
    _.difference(timeGrainRangeOptions[timeGrain], blackList);
};
